import Vue from 'vue';
import Router from 'vue-router';
import MainScreen from '@/components/MainScreen';
import Dashboard from '@/components/Dashboard';
import Fahrzeuge from '@/components/Fahrzeuge';
import Projekte from '@/components/Produkte';
import Zeiten from '@/components/Zeiten';
import Personen from '@/components/Personen';
import ExporterSettings from '@/components/ExporterSettings';
import Lohnarten from '@/components/Lohnarten';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainScreen,
      children: [
        {
          path: '/',
          component: Dashboard,
        },
        {
          path: '/fahrzeuge',
          component: Fahrzeuge,
        },
        {
          path: '/produkte',
          component: Projekte,
        },
        {
          path: '/personen',
          component: Personen,
        },
        {
          path: '/zeiten',
          component: Zeiten,
        },
        {
          path: '/exportersettings',
          component: ExporterSettings,
        },
        {
          path: '/lohnarten',
          component: Lohnarten,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
